import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Contractors/Contractors/tables";
import headers from "../../../../Data/Tables/Contractors/Contractors/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_suppliers } from "../../../../Controllers/Suppliers";

const ContractorsTable = () => {
  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [header, setHeader] = useState(headers);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      item: headerdata?.item,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    fetchData(data);
  };

  const actiondata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        catalog: tabledata?.catalog,
        status: tabledata?.status,
        type: 1,
      };

      const customers = await get_all_suppliers(params);

      if (customers?.status) {
        let data = [];

        customers?.data?.data?.map((value, index) => {
          data?.push({
            Name: value?.name,
            Email: value?.email,
            Phone: value?.phone,
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/contractors/edit/${value?._id}`}
                id={value?._id}
                api="delete-contractor"
                actiondata={actiondata}
              />
            ),
          });
        });

        setPagination({
          currentPage: customers?.data?.currentPage,
          totalCount: customers?.data?.totalCount,
          totalPages: customers?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(customers?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ContractorsTable;
